// extracted by mini-css-extract-plugin
export default {"content":"forbidden_content__nde-l","section":"forbidden_section__oSQbp","parentContainer":"forbidden_parentContainer__17ufF","btnContainer":"forbidden_btnContainer__8+kyY"};